import ProjectSubmissionMetaModalComponent from './submission-meta-modal.component'

const ProjectSubmissionMetaModalModule = angular.module('cdbl.project-submission-meta.manage-modal', [

])
  .component('cdblProjectSubmissionMetaModal', ProjectSubmissionMetaModalComponent)
  .name

export default ProjectSubmissionMetaModalModule
